module.exports = __webpack_public_path__ + "static/media/9.3040c70c.png";